
export default function authHeader() {
    let user = JSON.parse(localStorage.getItem('kendrick'));
    if (user && user.accessToken) {
        return { Authorization: '' + user.accessToken };
    } else {
    return {};
  }
}